import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  getContactRepTypeAction,
} from "../../../actions/CommonAction";

export const General = (props) => {

  const contactInfo = props.contactData;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getContactRepTypeAction("ContactRepType"));
  }, []);

  const Gstate = useSelector((state) => state) || {};
  const contactRepTypeData = Gstate.ContactDetailsEnumValues.ContactRepTypeData || [];

  const [showSocialSecurityText, setSocialSecurityShowText] = useState(false);
  const [showTaxText, setShowTaxText] = useState(false);
 
  const toggleSocialSecurityTextVisibility = () => {
    setSocialSecurityShowText(!showSocialSecurityText);
  };

  const toggleTaxTextVisibility = () => {
    setShowTaxText(!showTaxText);
  };

  const copyToClipboardBirthday = () => {
    const textToCopy = `${contactInfo.dateOfBirth}`;
    navigator.clipboard.writeText(textToCopy)      
  }; 
  const copyToClipboardSocialSecurity = () => {
    const textToCopy = `${contactInfo.socialSecurityValue}`;
    navigator.clipboard.writeText(textToCopy)      
  };
  const copyToClipboardTaxID = () => {
    const textToCopy = `${contactInfo.taxIDValue}`;
    navigator.clipboard.writeText(textToCopy)      
  }; 
  const copyToClipboardMobilePhone = () => {
    const textToCopy = `${contactInfo.mobileValue}`;
    navigator.clipboard.writeText(textToCopy)      
  }; 
  const copyToClipboardBusinessEmail = () => {
    const textToCopy = `${contactInfo.businessEmail1Value}`;
    navigator.clipboard.writeText(textToCopy)      
  }; 

  const getRepType = (repTypeValue) => {
 
    const selectedRepType = contactRepTypeData.find(
      (contactRepType) =>
        contactRepType && (contactRepType.EnumValue === parseInt(repTypeValue))
    );
  
    return selectedRepType ? selectedRepType : {};
  };
  
  const selectedRepType = getRepType(contactInfo?.repTypeValue);
 
  return (
    <>
      <div id="contacts" className="mainContentData">
        <br></br>
      
          <div className="col-lg-12 d-flex">
            <div className="col-lg-9">
              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Title</span>
                    <p className="fw-medium mb-0">{contactInfo.title || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Salutation</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.salutation || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">First Name</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.firstName || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Middle Name</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.middleName || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Last Name</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.lastName || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <br></br>
              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">D.O.B</span>
                    <span
                      onClick={copyToClipboardBirthday}
                      style={{ marginLeft: "60px" }}
                    >
                      <i class="fa-regular fa-copy"></i>
                    </span>
                    <p className="fw-medium mb-0">
                      {contactInfo.dateOfBirth
                        ? moment(contactInfo.dateOfBirth).format("MM/DD/YYYY")
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <div
                      className="fw-medium mb-0"
                      style={{ position: "relative" }}
                    >
                      <span className="fw-medium">Social Security</span>
                      <span
                        onClick={copyToClipboardSocialSecurity}
                        style={{ marginLeft: "15px" }}
                      >
                        <i class="fa-regular fa-copy"></i>
                      </span>
                    </div>

                    <div
                      className="fw-medium mb-0"
                      style={{ position: "relative" }}
                    >
                      <span>
                        <input
                          type={showSocialSecurityText ? "text" : "password"}
                          value={contactInfo.socialSecurityValue || "-"}
                        />
                      </span>
                      <span
                        className="contact-edit-eye"
                        onClick={toggleSocialSecurityTextVisibility}
                      >
                        {showSocialSecurityText ? (
                          <i className="fa-solid fa-eye"></i>
                        ) : (
                          <i className="fa-regular fa-eye-slash"></i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="mb-4">
                    <div
                      className="fw-medium mb-0"
                      style={{ position: "relative" }}
                    >
                      <span className="fw-medium">Tax ID Number</span>
                      <span
                        onClick={copyToClipboardTaxID}
                        style={{ marginLeft: "15px" }}
                      >
                        <i class="fa-regular fa-copy"></i>
                      </span>
                    </div>

                    <div
                      className="fw-medium mb-0"
                      style={{ position: "relative" }}
                    >
                      <span>
                        <input
                          type={showTaxText ? "text" : "password"}
                          value={contactInfo.taxIDValue || "-"}
                        />
                      </span>
                      <span
                        className="contact-edit-eye"
                        onClick={toggleTaxTextVisibility}
                      >
                        {showTaxText ? (
                          <i className="fa-solid fa-eye"></i>
                        ) : (
                          <i className="fa-regular fa-eye-slash"></i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-4">
                    <span className="fw-medium">Mother's Maiden Name</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.motherMaidenName || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <hr />
              </div>
            </div>
            <div className="col-lg-3 m-0">
              <div className="col-lg-12">
                <div className="col-md-12 ms-3">
                  <div className="mb-4">
                    <span className="fw-medium">Relationship Master</span>
                    <div className="mb-4">
                      <input
                        type="checkbox"
                        className="mb-0"
                        checked={contactInfo.isMaster === true}
                      />
                    </div>
                  </div>
                </div>
                <br></br>
                <div className="col-md-12 m-3">
                  <div className="mb-4">
                    <span className="fw-medium">Do Not Email</span>
                    <div className="mb-4">
                      <input
                        type="checkbox"
                        className="mb-0"
                        checked={contactInfo.doNotEmailValue !== "" ? contactInfo.doNotEmailValue !== "0" : ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <hr />
              </div>
            </div>
          </div>
          <div className="col-lg-12 d-flex">
            <div className="col-lg-9">
              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Company</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.companyName || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                <div className="mb-4">
                    <span className="fw-medium">Department</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.departmentValue || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                <div className="mb-4">
                    <span className="fw-medium">Job Title</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.jobTitle || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                <div className="mb-4">
                    <span className="fw-medium">Job Role</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.jobRole || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                
                </div>
                {contactInfo.contactTypeId === 2 ? (
    <div className="col-md-2">
      <div className="mb-4">
        <span className="fw-medium">Business Unit</span>
        <p className="fw-medium mb-0">
          {contactInfo.CompanyTypeName || "-"}
        </p>
      </div>
    </div>
) : null}

              </div>
              <div className="col-lg-11 px-0">
                <hr />
              </div>

              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Phone 1</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessPhone1Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Phone 2</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessPhone2Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Primary Contact</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.primaryContactValue || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Phone 1 Extn</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessPhone1ExtensionValue || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Phone 2 Extn</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessPhone2ExtensionValue || "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Mobile Phone</span>
                    <span
                      onClick={copyToClipboardMobilePhone}
                      style={{ marginLeft: "15px" }}
                    >
                      <i class="fa-regular fa-copy"></i>
                    </span>
                    <p className="fw-medium mb-0">
                      {contactInfo.mobileValue || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Fax Number</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.faxValue || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-11 px-0">
                <hr />
              </div>

              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Email</span>
                    <span
                      onClick={copyToClipboardBusinessEmail}
                      style={{ marginLeft: "15px" }}
                    >
                      <i class="fa-regular fa-copy"></i>
                    </span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessEmail1Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Email 2</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessEmail2Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Business Email 3</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.businessEmail3Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Personal Email 1</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.PersonalEmail1Value || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Personal Email 2</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.PersonalEmail2Value || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-11 px-0">
                <hr />
              </div>

              <div className="col-lg-12 row m-0 gap-3">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Investor Category</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.contactCategoryName || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Rep Type</span>
                    <p className="fw-medium mb-0">
                      {selectedRepType.EnumName || "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Intro Date</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.introductionDateValue !== ""
                        ? moment(contactInfo.introductionDateValue).format(
                            "MM/DD/YYYY"
                          )
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Created By</span>
                    <p className="fw-medium mb-0">
                      {contactInfo.createdByUserName}
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Created Date</span>
                    <p className="fw-medium mb-0">
                      {moment(contactInfo.createdDate).format("MM/DD/YYYY")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3  d-flex flex-column">

            <div className="my-3 bg-white life-science rounded py-md-2 py-lg-0 p-3 flex-grow-1" id="strategyDescription">
            <div
                class="accordion accordion-flush"
                id="accordionFlushExample"
              >
                <div style={{ marginTop: '13px' }}>
                  <span class="fw-medium" id="TextNotes">Biographical Info</span>
                  <div
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body" >
                      <p>
                        {contactInfo.BiographicalInfo || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-white life-science rounded py-md-2 py-lg-0 p-3 flex-grow-1" id="strategyDescription" style={{ backgroundColor: '#cfe2ff !important' }}>

              <div
                class="accordion accordion-flush"
                id="accordionFlushExample"
              >
                <div style={{ marginTop: '13px' }}>
                  <span class="fw-medium" id="TextNotes">Notes</span>
                  <div
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body" >
                      <p>
                        {contactInfo.contactNotes || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            </div>
            
        </div>
      </div>
    </>
  );
};
